(function () {
  function syncSelected(container) {
    if (!container) return;
    const checked = container.querySelector('input[type="radio"]:checked');
    if (!checked) return;
    
    const qty = parseInt(checked.dataset.qty || '0', 10);
    const discountPercent = parseFloat(checked.dataset.discountPercent || '0');
    const unitPrice = parseFloat(checked.dataset.unitPrice || '0');
    
    if (!qty) return;

    const inputId = container.dataset.quantityInputId;
    const qtyInput = inputId ? document.getElementById(inputId) : null;

    container.querySelectorAll('label.option-block-for-pdp').forEach((label) => {
      label.classList.toggle('selected', label.contains(checked));
    });

    if (!qtyInput) return;

    qtyInput.value = String(qty);
    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

    const form = qtyInput.closest('form');
    if (form) {
      const sectionId = form.id.replace('product-form-', '');
      let discountInput = document.getElementById('pack-discount-' + sectionId);
      
      if (discountInput) {
        discountInput.value = discountPercent;
      }
    }
  }

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (t.type !== 'radio') return;
    const container = t.closest('.product-options-for-pdp');
    if (!container) return;
    syncSelected(container);
  });

  function initAll() {
    document.querySelectorAll('.product-options-for-pdp').forEach(syncSelected);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();